import BaseRestClient from '@/assets/js/api/BaseRestClient'

class CoreWalletApiClient extends BaseRestClient {
  constructor(baseURL, errorCallback, successCallback) {
    super(baseURL, "CoreWalletApiClient", errorCallback, successCallback);
  }

  async getAccount(domain, accountId) {
    return await this.request("get", {
      domain,
      url: "/wallet/account/" + accountId,
    });
  }

  async getAccountByReference(domain, reference) {
    return await this.request("get", {
      domain,
      url: "/wallet/account/reference/" + encodeURIComponent(reference),
    });
  }

  async updateCreditLimit(domain, accountId, body) {
    return await this.request("put", {
      domain,
      url: "/wallet/account/" + accountId + "/credit-limit",
      body,
      successMsg: "Credit limit updated",
    });
  }

  async getTransactions(domain, accountId, limit = 100, offset = 0) {
    return await this.request("get", {
      domain,
      url: "/wallet/account/" + accountId + "/transactions",
      query: "limit=" + limit + "&offset=" + offset,
    });
  }

  async getTransaction(domain, transactionId) {
    return await this.request("get", {
      domain,
      url: "/wallet/transaction/" + transactionId,
    });
  }

  async getReservations(domain, accountId, limit = 100, offset = 0) {
    return await this.request("get", {
      domain,
      url: "/wallet/account/" + accountId + "/reservation",
      query: "limit=" + limit + "&offset=" + offset,
    });
  }

  async getReservation(domain, reservationId) {
    return await this.request("get", {
      domain,
      url: "/wallet/reservation/" + reservationId,
    });
  }
}

export default CoreWalletApiClient
